import { I18nThemed } from 'interfaces/mixins';
import { v } from '@dojo/framework/core/vdom';
export class LPIcon extends I18nThemed {
    render() {
        const { classes = [], name, element = 'div', icon = '' } = this.properties;
        const path = `${window.hcstatic.portal_cdn}/js/images/iconsheet.svg#${icon}`;
        return v(element, { key: name, classes, xqa: `lpicon ${name}` }, [
            v('svg', { 'xmlns:xlink': 'http://www.w3.org/1999/xlink', role: 'img' }, [
                v('use', { href: path, 'xlink:href': path })
            ])
        ]);
    }
}
export default LPIcon;
